module.exports = __webpack_public_path__ + "img/homepage-quick-links-boxes-arrows-toyota.59adcb71.png";